import mondaySdk from 'monday-sdk-js';

const monday = mondaySdk();

export const useMondaySdk = () => {
  return monday;
};
